import {
  DoryMessageType,
  DoryServiceType,
  DoryStreamingHeader,
  DoryStreamingMessage,
} from '../../abstract/StreamingMessages';

function getMarketDepthHeader(
  messageType: DoryMessageType
): DoryStreamingHeader {
  return {
    service: DoryServiceType.MARKETDEPTH,
    messageType,
    version: 'v1',
  };
}

type MarketDepthRequestPayload = {
  rics: string[];
};

export { getMarketDepthHeader, MarketDepthRequestPayload };

//#region Subscribe
type MarketDepthSubscribeHeader = {
  messageId: string;
} & DoryStreamingHeader;

type MarketDepthSubscribeRequest = {
  header: MarketDepthSubscribeHeader;
  payload: MarketDepthRequestPayload[];
} & DoryStreamingMessage;

type MarketDepthSubscribeResponse = {
  header: MarketDepthSubscribeHeader;
  payload: {
    status: number;
    message: string;
    subscription: {
      realtime: string[];
      delayed: string[];
      failed: string[];
    };
  };
} & DoryStreamingMessage;

function getMarketDepthSubscribeRequest(
  messageId: string,
  payload: MarketDepthRequestPayload[]
): MarketDepthSubscribeRequest {
  return {
    header: {
      ...getMarketDepthHeader(DoryMessageType.SUBSCRIBE),
      messageId,
    },
    payload: payload,
  };
}

export {
  MarketDepthSubscribeHeader,
  MarketDepthSubscribeRequest,
  MarketDepthSubscribeResponse,
  getMarketDepthSubscribeRequest,
};
//#endregion

//#region Snapshot
type MarketDepthSnapshotHeader = {
  messageId: string;
} & DoryStreamingHeader;
type MarketDepthSnapshotResponse = {
  header: MarketDepthSnapshotHeader;

  payload: [
    {
      ric: string;
      data: {
        [index: string]: {
          ASKSIZE?: string;
          NO_ASKMMKR?: string;
          ASK?: string;
          NO_BIDMMKR?: string;
          BID?: string;
          BIDSIZE?: string;
        };
      };
      removed?: number[];
      extra?: {
        TIMACT?: string;
        TIMACT_MS?: string;
      };
    }
  ];
} & DoryStreamingMessage;

export { MarketDepthSnapshotResponse };
//#endregion

//#region Update
type MarketDepthUpdateResponse = {
  header: DoryStreamingHeader;
  payload: [
    {
      ric: string;
      data: {
        [index: string]: {
          ASKSIZE?: string;
          NO_ASKMMKR?: string;
          ASK?: string;
          NO_BIDMMKR?: string;
          BID?: string;
          BIDSIZE?: string;
        };
      };
      extra?: {
        TIMACT_MS?: string;
      };
    }
  ];
} & DoryStreamingMessage;

export { MarketDepthUpdateResponse };
//#endregion

//#region Unsubscribe
type MarketDepthUnsubscribeRequest = {
  header: DoryStreamingHeader;
  payload: MarketDepthRequestPayload[];
} & DoryStreamingMessage;

type MarketDepthUnsubscribeResponse = {
  header: DoryStreamingHeader;
  payload: {
    status: number;
    message: string;
  };
} & DoryStreamingMessage;

function getMarketDepthUnsubscribeRequest(
  payload: MarketDepthRequestPayload
): MarketDepthUnsubscribeRequest {
  return {
    header: getMarketDepthHeader(DoryMessageType.UNSUBSCRIBE),
    payload: [payload],
  };
}

export {
  MarketDepthUnsubscribeRequest,
  MarketDepthUnsubscribeResponse,
  getMarketDepthUnsubscribeRequest,
};
//#endregion
